/**
 * Which images have a video start running, read synchronously. The animation status lives in React state, so two
 * clicks in one tick (the image's pill and the agent's button) would both still read it as idle.
 */
class AnimationRunsInFlight {
  #imageHashedIdsByChatId = new Map<string, Set<string>>();

  has(chatId: string, imageHashedId: string): boolean {
    return this.#imageHashedIdsByChatId.get(chatId)?.has(imageHashedId) ?? false;
  }

  add(chatId: string, imageHashedId: string): void {
    const imageHashedIds = this.#imageHashedIdsByChatId.get(chatId) ?? new Set<string>();
    imageHashedIds.add(imageHashedId);
    this.#imageHashedIdsByChatId.set(chatId, imageHashedIds);
  }

  remove(chatId: string, imageHashedId: string): void {
    const imageHashedIds = this.#imageHashedIdsByChatId.get(chatId);
    imageHashedIds?.delete(imageHashedId);

    if (imageHashedIds?.size === 0) {
      this.#imageHashedIdsByChatId.delete(chatId);
    }
  }
}

export const animationRunsInFlight = new AnimationRunsInFlight();
